module.exports = __webpack_public_path__ + "assets/img/c5fe6c3a9282cb6037fffb0e549bcd72.svg";